import { useDispatch, useSelector } from 'react-redux';

import WarningLoaderCircle from '@perpay-web/components/base/WarningLoaderCircle/WarningLoaderCircle';
import { analyticsCardRejectedClickDashboardFooter } from '@perpay-web/fintech/actions/analytics/cardOnboardingMVP2';
import {
    analyticsCKPartnerHostedOnboardingRejectionScreen,
    analyticsCKPartnerHostedOnboardingApplicationRejectedClickDashboard,
} from '@perpay-web/fintech/actions/analytics/partnerHostedOnboarding';
import PartnerHostedOnboardingRejectedSwitcher from '@perpay-web/fintech/components/screens/PartnerHostedOnboardingRejectedSwitcher/PartnerHosterOnboardingRejectedSwitcher';
import {
    getPassedIdv,
    fetchCardAccountApplicationDataModule,
} from '@perpay-web/fintech/dataModules/fetchCardAccountApplications';

const PartnerHostedOnboardingRejectedContainer = ({ partnerCode }) => {
    const dispatch = useDispatch();
    const passedKyc = useSelector(getPassedIdv);
    const isLoadingOrUnrequested = useSelector(
        fetchCardAccountApplicationDataModule.getIsLoadingOrUnrequested,
    );

    if (isLoadingOrUnrequested) {
        return <WarningLoaderCircle />;
    }

    const handlers = {
        onMountCreditKarma: () => {
            dispatch(analyticsCKPartnerHostedOnboardingRejectionScreen());
        },
        onClickDashboardCreditKarma: () => {
            dispatch(
                analyticsCKPartnerHostedOnboardingApplicationRejectedClickDashboard(),
            );
        },
        onClickDashboardStandard: () => {
            dispatch(analyticsCardRejectedClickDashboardFooter());
        },
    };

    return (
        <PartnerHostedOnboardingRejectedSwitcher
            partnerCode={partnerCode}
            passedKyc={passedKyc}
            handlers={handlers}
        />
    );
};

export default PartnerHostedOnboardingRejectedContainer;
